<template>
  <div>
    <section class="why-difficulties lightaccent-bg">
      <b-container class="contents">
        <b-row>
          <b-col>
            <h2 class="text-center mb-4 pb-2 mb-lg-5 pb-lg-0">
              People living with ADHD may struggle with:
            </h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <ul class="m-0 list-1">
              <li>
                <p class="text-black">Morning routines or lateness</p>
              </li>
              <li>
                <p class="text-black">Evening routines</p>
              </li>
              <li>
                <p class="text-black">Organizing tasks</p>
              </li>
              <li>
                <p class="text-black">Following directions</p>
              </li>
              <li>
                <p class="text-black mb-0">Getting distracted easily</p>
              </li>
            </ul>
          </b-col>
          <b-col md="5" class="offset-md-1">
            <ul class="m-0 list-2">
              <li>
                <p class="text-black">Paying attention and staying focused</p>
              </li>
              <li>
                <p class="text-black">Finishing tasks</p>
              </li>
              <li>
                <p class="text-black">Remaining quiet during tasks</p>
              </li>
              <li>
                <p class="text-black">Listening and responding to others</p>
              </li>
              <li>
                <p class="text-black mb-0">Restlessness</p>
              </li>
            </ul>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="why-difficulties pb-0">
      <b-container class="contents pb-0 talk-doctor-text">
        <b-row>
          <b-col>
            <p class="text-black text-center m-0">
              Talk to your doctor to learn more about ADHD in adults or
              children. This is not all you need to know about ADHD.
            </p>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
export default {
  name: "WhyDifficulties",
};
</script>
